import React from 'react'
import PropTypes from 'prop-types'
import { IconMaps } from '@ow/icons'
import { StyledAvatar } from '../avatar/styled/avatar'

// 只做头像展示
const AvatarImg = (props) => {
  const {
    style,
    backgroundColor,
    className,
    width,
    height,
    userInfo,
    onClick,
    size,
    fill,
  } = props

  return (
    <StyledAvatar
      style={style}
      backgroundColor={backgroundColor}
      className={className}
      width={width}
      height={height}
      onClick={onClick}
    >
      {userInfo.avatar ? (
        <img src={userInfo.avatar} alt="" />
      ) : (
        <IconMaps
          type="user"
          width={size}
          height={size}
          size={24}
          fill={fill}
        />
      )}
    </StyledAvatar>
  )
}

// 默认参数
AvatarImg.defaultProps = {
  style: {},
  backgroundColor: undefined,
  className: undefined,
  width: 40,
  height: 40,
  size: 24,
  fill: '#fff',
  userInfo: undefined,
  onClick: null,
}

// 参数类型
AvatarImg.propTypes = {
  style: PropTypes.shape({}),
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  size: PropTypes.number,
  fill: PropTypes.string,
  userInfo: PropTypes.shape({}),
  onClick: PropTypes.func,
}

export default AvatarImg
